import { Expose } from 'class-transformer'

export class EbookOverviewSaleType {
  @Expose() id: number

  @Expose() name: string

  @Expose({ name: 'totalSales' }) value: number
}
